import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { EXCLUDED_DISCOUNTED_PRODUCTS_CUSTOM_CODE } from './useGetAlgoliaProductWithoutDiscountDiscountExperiment'

export const removeDiscountFromCrossSellProduct = (
  product: CrossSellProduct,
): CrossSellProduct => {
  const { custom_usecases, price } = product

  if (custom_usecases.includes(EXCLUDED_DISCOUNTED_PRODUCTS_CUSTOM_CODE)) {
    return product
  }

  return {
    ...product,
    ersparnis_prozent_text: '',
    oldprice: price,
    reduced: 'false',
  }
}
